import React from 'react'

import { Table, TableCol, TableRow } from '../../../../components/pdf/Table'
import Text from '../../../../components/pdf/Text'
import Grid from '../../../../components/pdf/Grid'

const Header = ({ headerValues, category }) => {
  return (
    <Table width="100%" useFontBaseColor>
      <TableRow useFontBaseColor>
        <TableCol useFontBaseColor>
          <Text semibold>Tipo de Documento:</Text>
        </TableCol>
        <TableCol bgColor={'#000'} useFontBaseColor>
          <Text semibold color={'#fff'} align="center">
            {headerValues.tipo}
          </Text>
        </TableCol>
        <TableCol useFontBaseColor>
          <Grid justify="space-between">
            <Text>
              <b>Código:</b>
            </Text>
            <Text>{headerValues.codigo}</Text>
          </Grid>
        </TableCol>
      </TableRow>
      <TableRow useFontBaseColor>
        <TableCol useFontBaseColor>
          <Text semibold>Título:</Text>
        </TableCol>
        <TableCol useFontBaseColor>
          <Text>{headerValues.titulo}</Text>
        </TableCol>
        <TableCol useFontBaseColor>
          <Grid justify="space-between">
            <Text>
              <b>Data de Emissão:</b>
            </Text>
            <Text>{headerValues.dataEmissao}</Text>
          </Grid>
        </TableCol>
      </TableRow>
      <TableRow useFontBaseColor>
        <TableCol useFontBaseColor>
          <Text semibold>Emitente:</Text>
        </TableCol>
        <TableCol useFontBaseColor>
          <Text>{headerValues.emitente}</Text>
        </TableCol>
        <TableCol useFontBaseColor>
          <Text>
            <b>No/Data de Revisão:</b>
          </Text>
        </TableCol>
      </TableRow>
      <TableRow useFontBaseColor>
        <TableCol useFontBaseColor>
          <Text semibold>Classificação:</Text>
        </TableCol>
        <TableCol colSpan={2} useFontBaseColor>
          <Text semibold color="#FF0000">
            {headerValues.classificacao?.toUpperCase()}
          </Text>
        </TableCol>
      </TableRow>
      <TableRow useFontBaseColor>
        <TableCol bgColor={'#000'} colSpan={3} useFontBaseColor>
          <Text semibold color={'#fff'} align={'center'}>
            {category}
          </Text>
        </TableCol>
      </TableRow>
      <TableRow useFontBaseColor>
        <TableCol useFontBaseColor>
          <Text semibold>Local avaliado:</Text>
        </TableCol>
        <TableCol colSpan={2} useFontBaseColor>
          <Text>{headerValues.local}</Text>
        </TableCol>
      </TableRow>
      <TableRow useFontBaseColor>
        <TableCol useFontBaseColor>
          <Text semibold>Endereço:</Text>
        </TableCol>
        <TableCol colSpan={2} useFontBaseColor>
          <Text>{headerValues.endereco}</Text>
        </TableCol>
      </TableRow>
      <TableRow useFontBaseColor>
        <TableCol useFontBaseColor>
          <Text semibold>Consultor:</Text>
        </TableCol>
        <TableCol colSpan={2} useFontBaseColor>
          <Text>{headerValues.consultor}</Text>
        </TableCol>
      </TableRow>
      <TableRow useFontBaseColor>
        <TableCol useFontBaseColor>
          <Text semibold>Entrevistados:</Text>
        </TableCol>
        <TableCol colSpan={2} useFontBaseColor>
          <Text style={{ whiteSpace: 'pre-line' }}>{headerValues.entrevistados}</Text>
        </TableCol>
      </TableRow>
      <TableRow useFontBaseColor>
        <TableCol useFontBaseColor>
          <Text semibold>Data da Avaliação:</Text>
        </TableCol>
        <TableCol colSpan={2} useFontBaseColor>
          <Text>{headerValues.dataAvaliacao}</Text>
        </TableCol>
      </TableRow>
    </Table>
  )
}

export default Header
